export default "__VITE_ASSET__DYuWFLIQ__"